import { result, task, type Result, type Task } from 'true-myth';

/**
 * A failure, for Tasks or Results, that keeps the original error, if any, as `cause`
 */
export class ChainedError extends Error {
  override readonly name: string = 'ChainedError';

  static of(message: string, cause?: unknown): ChainedError {
    return new ChainedError(message, cause === undefined ? undefined : { cause });
  }
}

/**
 * Formats a failure reason into a string with a label
 */
export const reason =
  (label: string) =>
  (reason: unknown): string =>
    `${label}: ${reason instanceof Error ? reason.message : String(reason)}`;

export const throwError = (reason: string): never => {
  throw new Error(reason);
};

/**
 * Runs `fn`, turning a sync throw or a rejection into a rejected Task of `reason(label)`
 */
export const tryTask = <T>(label: string, fn: () => T | PromiseLike<T>): Task<T, string> =>
  task.tryOrElse(reason(label), async () => fn());

/**
 * Runs `fn`, turning a throw into an Err of `reason(label)`
 */
export const tryResult = <T>(label: string, fn: () => T): Result<T, string> => result.tryOrElse(reason(label), fn);
